import { Brand, Position, State } from 'src/types'
import { dxmCanvasGloveBack } from 'src/features/brands/dxm/canvas/rightThrow/glove/back/useDxmCanvasGloveBack'
import { ysrCanvasGloveBack } from 'src/features/brands/yellStory/canvas/glove/back/useYsrCanvasGloveBack'
import { ragdelionCanvasGloveBack } from 'src/features/brands/ragdelion/canvas/glove/rightThrow/back/useRagdelionCanvasGloveBack'
import { gorillaCanvasGloveBack } from 'src/features/brands/gorilla/canvas/glove/rightThrow/back/useGorillaCanvasGloveBack'
import { treasureCanvasGloveBack } from 'src/features/brands/treasure/canvas/glove/back/useTreasureCanvasGloveBack'
import { atomsCanvasGloveBack, atomsUsModelCanvasGloveBack } from 'src/features/brands/atoms/canvas/rightThrow/glove/back/useAtomsCanvasGloveBack'
import { atomsCanvasCatcherMittBack } from 'src/features/brands/atoms/canvas/rightThrow/catchermitt/back/useAtomsCanvasCatcherMittBack'
import { atomsCanvasFirstMittBack } from 'src/features/brands/atoms/canvas/rightThrow/firstmitt/back/useAtomsCanvasFirstMittBack'
import { ragdelionCanvasCatcherMittBack } from 'src/features/brands/ragdelion/canvas/catchermitt/rightThrow/back/useRagdelionCanvasCatcherMittBack'
import { ragdelionCanvasFirstMittBack } from 'src/features/brands/ragdelion/canvas/firstmitt/rightThrow/back/useRagdelionCanvasFirstMittBack'
import { treasureCanvasCatcherMittBack } from 'src/features/brands/treasure/canvas/catchermitt/back/useTreasureCanvasCatcherMittBack'
// import { treasureCanvasFirstMittBack } from 'src/features/brands/treasure/canvas/firstmitt/back/useTreasureCanvasFirstMittBack'
import { gorillaCanvasFirstMittBack } from 'src/features/brands/gorilla/canvas/firstmitt/rightThrow/back/useGorillaCanvasFirstMittBack'
import { gorillaCanvasCatcherMittBack } from 'src/features/brands/gorilla/canvas/catchermitt/rightThrow/back/useGorillaCanvasCatcherMittBack'
import { atomsCanvasGloveBackLeftThrow } from 'src/features/brands/atoms/canvas/leftThrow/glove/back/useAtomsCanvasGloveBack'
import { atomsCanvasCatcherMittBackLeftThrow } from 'src/features/brands/atoms/canvas/leftThrow/catchermitt/back/useAtomsCanvasCatcherMittBack'
import { ragdelionCanvasCatcherMittBackLeftThrow } from 'src/features/brands/ragdelion/canvas/catchermitt/leftThrow/back/useRagdelionCanvasCatcherMittBack'
import { atomsCanvasFirstMittBackLeftThrow } from 'src/features/brands/atoms/canvas/leftThrow/firstmitt/back/useAtomsCanvasFirstMittBack'
import { ragdelionCanvasFirstMittBackLeftThrow } from 'src/features/brands/ragdelion/canvas/firstmitt/leftThrow/back/useRagdelionCanvasFirstMittBack'
import { gorillaCanvasFirstMittBackLeftThrow } from 'src/features/brands/gorilla/canvas/firstmitt/leftThrow/back/useGorillaCanvasFirstMittBack'
import { dxmCanvasGloveBackLeftThrow } from 'src/features/brands/dxm/canvas/leftThrow/glove/back/useDxmCanvasGloveBack'
import { ragdelionCanvasGloveBackLeftThrow } from 'src/features/brands/ragdelion/canvas/glove/leftThrow/back/useRagdelionCanvasGloveBack'
import { gorillaCanvasGloveBackLeftThrow } from 'src/features/brands/gorilla/canvas/glove/leftThrow/back/useGorillaCanvasGloveBack'
import { dxmCanvasCatcherMittBack } from 'src/features/brands/dxm/canvas/rightThrow/catcher/back/useDxMCanvasCatcherMittBack'
import { dxmCanvasCatcherMittBackLeftThrow } from 'src/features/brands/dxm/canvas/leftThrow/catcher/back/dxmCanvasCatcherMittBack'
import { dxmCanvasFirstMittBackLeftThrow } from 'src/features/brands/dxm/canvas/leftThrow/firstmitt/back/useDxmCanvasFirstMittBack'
import { dxmCanvasFirstMittBack } from 'src/features/brands/dxm/canvas/rightThrow/firstmitt/back/useDxmCanvasFirstMittBack'
import { usModelOfAtomsChecker } from 'src/features/brands/atoms/helper'

export const genBackImgFromCanvas = (state: State, brand: Brand, beforeCheckPosition: Position, domId?: string) => {
  const position: Position = Array.isArray(beforeCheckPosition) ? beforeCheckPosition[0] : beforeCheckPosition // 2024/08/01くらいになったら削除
  const canvas = document.getElementById(domId || 'canvasBack') as HTMLCanvasElement
  const ctx = canvas.getContext('2d')
  ctx.clearRect(0, 0, 900, 652)
  ctx.strokeStyle = '#282828'
  ctx.lineWidth = 2
  const canvasWidth = canvas.width
  const dominantArm = state.dominantArm.value
  const productNumber = state.baseModel?.productNumber
  if (usModelOfAtomsChecker(productNumber)) {
    atomsUsModelCanvasGloveBack(ctx, state, position)
    return
  }
  switch (position) {
    case 'catcher':
      switch (brand) {
        case 'atoms':
          switch (dominantArm) {
            case 'leftThrow':
              atomsCanvasCatcherMittBackLeftThrow(ctx, state, canvasWidth)
              break
            default:
              atomsCanvasCatcherMittBack(ctx, state)
              break
          }
          break
        case 'ragdelion':
          switch (dominantArm) {
            case 'leftThrow':
              ragdelionCanvasCatcherMittBackLeftThrow(ctx, state, canvasWidth)
              break
            default:
              ragdelionCanvasCatcherMittBack(ctx, state)
              break
          }
          break
        case 'treasure':
          treasureCanvasCatcherMittBack(ctx, state)
          break
        case 'gorilla':
          gorillaCanvasCatcherMittBack(ctx, state)
          break
        case 'dxm':
          switch (dominantArm) {
            case 'leftThrow':
              dxmCanvasCatcherMittBackLeftThrow(ctx, state, canvasWidth)
              break
            default:
              dxmCanvasCatcherMittBack(ctx, state)
              break
          }
          break
      }
      break
    case 'first':
      switch (brand) {
        case 'atoms':
          switch (dominantArm) {
            case 'leftThrow':
              atomsCanvasFirstMittBackLeftThrow(ctx, state, canvasWidth)
              break
            default:
              atomsCanvasFirstMittBack(ctx, state)
              break
          }
          break
        case 'ragdelion':
          switch (dominantArm) {
            case 'leftThrow':
              ragdelionCanvasFirstMittBackLeftThrow(ctx, state, canvasWidth)
              break
            default:
              ragdelionCanvasFirstMittBack(ctx, state)
              break
          }
          break
        case 'dxm':
          switch (dominantArm) {
            case 'leftThrow':
              dxmCanvasFirstMittBackLeftThrow(ctx, state, canvasWidth)
              break
            default:
              dxmCanvasFirstMittBack(ctx, state)
              break
          }
          break
        // case 'treasure':
        //   treasureCanvasFirstMittBack(ctx, state)
        //   break
        case 'gorilla':
          switch (dominantArm) {
            case 'leftThrow':
              gorillaCanvasFirstMittBackLeftThrow(ctx, state, canvasWidth)
              break
            default:
              gorillaCanvasFirstMittBack(ctx, state)
              break
          }
          break
      }
      break
    default:
      switch (brand) {
        case 'atoms':
          switch (dominantArm) {
            case 'leftThrow':
              atomsCanvasGloveBackLeftThrow(ctx, state, position, canvasWidth)
              break
            default:
              atomsCanvasGloveBack(ctx, state, position)
              break
          }
          break
        case 'yellStory':
          ysrCanvasGloveBack(ctx, state)
          break
        case 'dxm':
          switch (dominantArm) {
            case 'leftThrow':
              dxmCanvasGloveBackLeftThrow(ctx, state, position, canvasWidth)
              break
            default:
              dxmCanvasGloveBack(ctx, state, position)
              break
          }
          break
        case 'ragdelion':
          switch (dominantArm) {
            case 'leftThrow':
              ragdelionCanvasGloveBackLeftThrow(ctx, state, position, canvasWidth)
              break
            default:
              ragdelionCanvasGloveBack(ctx, state, position)
              break
          }
          break
        case 'gorilla':
          switch (dominantArm) {
            case 'leftThrow':
              gorillaCanvasGloveBackLeftThrow(ctx, state, position, canvasWidth)
              break
            default:
              gorillaCanvasGloveBack(ctx, state, position)
              break
          }
          break
        case 'treasure':
          treasureCanvasGloveBack(ctx, state, position)
          break
      }
      break
  }
  setTimeout(function () {
    return canvas.toDataURL()
  }, 2000)
}
